import { render } from "./CollectionSettings.vue?vue&type=template&id=42b66376&scoped=true"
import script from "./CollectionSettings.vue?vue&type=script&lang=js"
export * from "./CollectionSettings.vue?vue&type=script&lang=js"

import "./CollectionSettings.vue?vue&type=style&index=0&id=42b66376&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b66376"]])

export default __exports__